export const magicLinkCandidateStoreKey = 'magicLinkCandidate';
